<ham-button
    class="archive-button"
    variant="white"
    size="xs"
    (buttonClick)="openDialog()"
    icon="assets/hamIcons/arrows-repeat.svg"
    >REDO</ham-button
>

<ham-modal *ngIf="openRedoChangeConfirmationDialog" [size]="'sm'" (cancel)="cancelRedo()" [hideFooter]="true">
    <div class="flex-center">
        <span class="ham-icon exclamation-wrapper">
            <i class="exclamation-outline-icon"></i>
        </span>
        <span class="workflow-text1">{{ 'aumico_annualreport_redo_confirmation_title' | i18next }}</span>
        <span class="workflow-text2">
            {{ 'aumico_annualreport_redo_confirmation_description' | i18next }}
        </span>
        <div class="workflow-buttons">
            <span>
                <ham-button
                    class="workflow-cancel-button"
                    size="sm"
                    (buttonClick)="cancelRedo()"
                    type="submit"
                    variant="transparent"
                    outline="true"
                    variant="white"
                >
                    {{ 'aumico_companies_workflow_change_cancel' | i18next }}
                </ham-button>
            </span>
            <span>
                <ham-button
                    class="workflow-confirm-button"
                    size="sm"
                    (buttonClick)="confirmRedo()"
                    type="submit"
                    variant="red"
                >
                    {{ 'aumico_companies_workflow_change_confirm' | i18next }}
                </ham-button>
            </span>
        </div>
    </div></ham-modal
>
